import { render, staticRenderFns } from "./venueList.vue?vue&type=template&id=8a42219c&scoped=true&"
import script from "./venueList.vue?vue&type=script&lang=js&"
export * from "./venueList.vue?vue&type=script&lang=js&"
import style0 from "./venueList.vue?vue&type=style&index=0&id=8a42219c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a42219c",
  null
  
)

export default component.exports